import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, MapPin, Send, CheckCircle2 } from 'lucide-react';
export function Contact() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => setStatus('success'), 1200);
  };
  return <div className="bg-gray-50 min-h-screen" data-id="element-320">
      <div className="bg-white border-b border-gray-200" data-id="element-321">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-322">
          <h1 className="text-3xl md:text-4xl font-extrabold text-yarbo-dark mb-2" data-id="element-323">
            Contact Merem Robotics
          </h1>
          <p className="text-gray-600 max-w-2xl" data-id="element-324">
            Order support, product selection help, and general questions about
            Yarbo systems.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-325">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-326">
          {/* Info */}
          <div className="lg:col-span-1 space-y-4" data-id="element-327">
            <div className="bg-white p-6 rounded-2xl border border-gray-200" data-id="element-328">
              <h3 className="font-bold text-yarbo-dark mb-4" data-id="element-329">Reach Us</h3>
              <div className="space-y-4 text-sm" data-id="element-330">
                <div className="flex items-start gap-3" data-id="element-331">
                  <Mail className="w-5 h-5 text-yarbo-yellow mt-0.5" data-id="element-332" />
                  <div data-id="element-333">
                    <div className="font-bold text-gray-900" data-id="element-334">Email</div>
                    <div className="text-gray-600" data-id="element-335">[Email]</div>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-336">
                  <MapPin className="w-5 h-5 text-yarbo-yellow mt-0.5" data-id="element-337" />
                  <div data-id="element-338">
                    <div className="font-bold text-gray-900" data-id="element-339">Location</div>
                    <div className="text-gray-600" data-id="element-340">Michigan, USA</div>
                    <div className="text-xs text-gray-500 mt-1" data-id="element-341">
                      Shipping nationwide
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-yarbo-charcoal text-white p-6 rounded-2xl" data-id="element-342">
              <h3 className="font-bold mb-3" data-id="element-343">Common Topics</h3>
              <ul className="space-y-2 text-sm text-gray-300" data-id="element-344">
                <li data-id="element-345">• Help choosing the right Yarbo system</li>
                <li data-id="element-346">• Order status and tracking</li>
                <li data-id="element-347">• Shipping & returns questions</li>
                <li data-id="element-348">• Module compatibility questions</li>
              </ul>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-2" data-id="element-349">
            <div className="bg-white p-8 rounded-2xl border border-gray-200" data-id="element-350">
              {status === 'success' ? <motion.div initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} className="text-center py-10" data-id="element-351">
                  <CheckCircle2 className="w-14 h-14 text-green-500 mx-auto mb-4" data-id="element-352" />
                  <h3 className="text-2xl font-bold text-yarbo-dark mb-2" data-id="element-353">
                    Message sent
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-354">
                    Thanks for reaching out. We'll reply by email.
                  </p>
                  <button onClick={() => setStatus('idle')} className="text-sm font-bold text-yarbo-dark hover:underline" data-id="element-355">
                    Send another message
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-356">
                  <h3 className="text-2xl font-bold text-yarbo-dark mb-4" data-id="element-357">
                    Send us a message
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-358">
                    <div data-id="element-359">
                      <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-360">
                        Name *
                      </label>
                      <input type="text" required className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none" data-id="element-361" />
                    </div>
                    <div data-id="element-362">
                      <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-363">
                        Email *
                      </label>
                      <input type="email" required className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none" data-id="element-364" />
                    </div>
                  </div>

                  <div data-id="element-365">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-366">
                      Topic
                    </label>
                    <select className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none bg-white" data-id="element-367">
                      <option data-id="element-368">Product selection help</option>
                      <option data-id="element-369">Order status</option>
                      <option data-id="element-370">Shipping & returns</option>
                      <option data-id="element-371">Module compatibility</option>
                      <option data-id="element-372">General question</option>
                    </select>
                  </div>

                  <div data-id="element-373">
                    <label className="block text-sm font-bold text-gray-700 mb-1" data-id="element-374">
                      Message *
                    </label>
                    <textarea required rows={5} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:ring-2 focus:ring-yarbo-yellow focus:border-transparent outline-none resize-none" data-id="element-375" />
                  </div>

                  <button type="submit" disabled={status === 'submitting'} className="w-full bg-yarbo-dark text-white font-bold py-4 rounded-lg hover:bg-black transition-colors flex justify-center items-center gap-2" data-id="element-376">
                    {status === 'submitting' ? 'Sending...' : <>
                        Send Message <Send className="w-4 h-4" data-id="element-377" />
                      </>}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}